<template>
  <svg-icon name="Msg-Warning" size="16px"></svg-icon>
</template>
